import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Table from './table';

const CoachTypes = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (user?.permissions?.coach_types?.add_edit) {
    setCanUpdate(true);
    }
  }, [user]);

  return (
    <div className='page-top-div'>
      <span className='text-span'>Coach Types Manager</span>
      <Table canUpdate={canUpdate} />
    </div>
  );
};

export default CoachTypes;
